import React from "react";

const AboutSection = () => {

  return (
    
    <section id="about" className="py-10 container mx-auto px-6">
      <h3 className="text-xl font-bold italic text-center mb-10">
        About LeagueSphere
      </h3>

      <div className="bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 p-6 rounded-xl shadow-lg max-w-8xl mx-auto my-8 text-center">
        <p className="text-gray-800 font-medium italic text-lg md:text-lg mb-6">
          We built LeagueSphere to empower local sports organizers, schools, and
          communities to run tournaments like professionals — without complex
          tools or paperwork. From booking playgrounds to managing leagues, we make it simple to organize, promote, and grow local sports tournaments. A platform to manage tournaments, register teams,
          update scores, engage your audience – and even{" "}
          <span className="font-bold text-blue-700">
            book playgrounds or sports venues
          </span>{" "}
          – all in one place.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-gray-700 font-semibold text-sm">
          <span className="flex items-center gap-2">
            <span className="text-green-500">✅</span> For Organizers
          </span>
          <span className="flex items-center gap-2">
            <span className="text-green-500">✅</span> For Teams
          </span>
          <span className="flex items-center gap-2">
            <span className="text-green-500">✅</span> For Fans
          </span>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 text-center">
        <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
          <h4 className="font-semibold text-lg">Who Can Use It?</h4>
          <p className="text-gray-600">
            Cricket, Football, Basketball, Volleyball, Tennis & more.
          </p>
        </div>
        <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
          <h4 className="font-semibold text-lg">For Institutions</h4>
          <p className="text-gray-600">
            Schools & Colleges managing annual sports events.
          </p>
        </div>
        <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
          <h4 className="font-semibold text-lg">For Communities</h4>
          <p className="text-gray-600">
            Local clubs & groups running neighborhood tournaments.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;